/**
 * Get General Settings Use Case
 * Fetches current DCS App configuration for the operator
 */

import { GeneralSettingsRepository } from '../data/general-settings-repository';
import { DcsApp } from '../types/general-settings-types';

export class GetGeneralSettingsUseCase {
  constructor(private repository: GeneralSettingsRepository) {}

  /**
   * Execute: Fetch general settings (DCS App)
   * @returns Promise<DcsApp | null> - Returns null if no app found
   */
  async execute(operatorId?: number): Promise<DcsApp | null> {
    console.log('[GetGeneralSettingsUseCase] Executing...');

    try {
      const app = await this.repository.getSettings(operatorId);

      console.log('[GetGeneralSettingsUseCase] Success:', {
        appId: app?.appId,
        operatorId: app?.operatorId
      });

      return app;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      console.error('[GetGeneralSettingsUseCase] Failed:', errorMessage);
      throw error;
    }
  }
}
